import { axios } from '@/di-container/axios';
import {
  GetScrapsGateway,
  GetScrapCategoriesGateway,
  CreateScrapGateway,
  DeleteScrapGateway,
  GetScrapsCountGateway,
} from '@remodeling/common';

export const scrapGateway = () => {
  return {
    getScraps: new GetScrapsGateway(axios),
    getScrapCategories: new GetScrapCategoriesGateway(axios),
    createScraps: new CreateScrapGateway(axios),
    deleteScraps: new DeleteScrapGateway(axios),
    getCount: new GetScrapsCountGateway(axios),
  };
};
